import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import {
  IHnInvoiceApplicationOrders,
  IHnInvoiceApplyItem,
  IInvoiceApplyPageParams,
  IInvoiceDetailItem,
  IInvoiceDetailParams,
  IInvoiceSubjectAndTaxItem,
  IOrdersCheckParams,
  ISubmitInvoiceParams,
  ITaxInvoiceDetailParams,
  IWarningFreelancer,
  IWarningOrdersList,
  IWarningOrdersParams,
  IInvoicePayH5UrlParams,
  IInvoicePayH5Url,
  IHnInvoiceDetailParams,
  IHnInvoiceDetailItem,
  IInvoiceApplyRecordParams,
  IInvoiceApplyRecordItem,
  IRecordSubjectListParams,
  IMonthInvoiceStatistics,
  IMonthInvoiceParams,
  IMonthInvoiceItem,
  IMonthCompanyItem,
  ICrowdInvoiceApplyParams,
  ICrowdInvoiceApplyItem,
  ICrowdInvoiceSubjectAndDutyList,
  IComputeFreeTaxOrderAmount,
  IExportTaxInvoicesParams,
  IMatchTaxOrderAmountReq,
  ICrowdServerItem,
  ICrowdCompanyItem,
  IUploadApplyFile,
  EHnInvoiceType,
  ICheckInoviceRes,
} from '@core/main/types';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 完税开票 - 异常订单
 */
export async function queryOrdersCheck(param: IOrdersCheckParams) {
  let data = [] as IWarningFreelancer[];
  let total = 0;
  let warningOrderCount = undefined;
  let warningOrderAmount = undefined;

  param = JSON.parse(JSON.stringify(param)) as IOrdersCheckParams;

  try {
    const { code, context, message } = await Http.post<{ data: IWarningFreelancer[]; total: number; warningOrderCount: number; warningOrderAmount: number }>
    (`${hostUrl}/pay/tax-invoice/match-orders-freelancer-check`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all, warningOrderCount: orderCount, warningOrderAmount: orderAmount } = context || {} as { data: IWarningFreelancer[]; total: number; warningOrderCount: number; warningOrderAmount: number };

      data = items || [];
      total = all || 0;
      warningOrderCount = orderCount || 0;
      warningOrderAmount = orderAmount || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
    warningOrderCount,
    warningOrderAmount,
  };
}

/**
 * 完税开票 - 开票科目列表
 */
export async function queryInvoiceSubjectAndTax(id?: number, isCrowd?: boolean) {
  let data = [] as IInvoiceSubjectAndTaxItem[];

  try {
    const { code, context, message } = await Http.post<IInvoiceSubjectAndTaxItem[]> (`${hostUrl}/pay/tax-invoice/query-${isCrowd ? 'crowd' : 'match'}-order-invoice-subject-and-tax-list`,
      {
        companyId: isCrowd ? undefined : id,
        serverId: isCrowd ? id : undefined,
      },
    );

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || {} as IInvoiceSubjectAndTaxItem[];

      data = items || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 完税开票 - 开票科目子订单分页
 */
export async function querySubjectOrderDetailPage(param: IInvoiceDetailParams, isCrowd: boolean = false) {
  let data = [] as IInvoiceDetailItem[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IInvoiceDetailParams;

  try {
    const { code, context, message } = await Http.post<{ data: IInvoiceDetailItem[]; total: number }> (`${hostUrl}/pay/tax-invoice/page-query-subject-${isCrowd ? 'crowd' : 'match'}-order-detail`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IInvoiceDetailItem[]; total: number; warningOrderCount: number; warningOrderAmount: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 完税开票 - 开票申请
 */
export async function submitInvoiceApplication(param: ISubmitInvoiceParams, isCrowd: boolean = false) {
  param = JSON.parse(JSON.stringify(param)) as ISubmitInvoiceParams;

  try {
    const { code, message } = await Http.post (`${hostUrl}/pay/tax-invoice/submit-${isCrowd ? 'crowd' : 'match'}-orders-hn-invoice-application`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 完税开票 - 异常订单（撮合业务）
 */
export async function queryWarningOrdersList(companyId: number) {
  let data = [] as IWarningOrdersList[];

  try {
    const { code, context, message } = await Http.post<IWarningOrdersList[]> (`${hostUrl}/pay/tax-invoice/query-warning-orders-invoice-subjects`, { companyId });

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IWarningOrdersList[];

      data = items || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 完税开票 - 完税发票详情
 */
export async function queryInvoiceApplicationDetail(param: ITaxInvoiceDetailParams) {
  let data = {} as IHnInvoiceApplicationOrders;

  try {
    const { code, context, message } = await Http.post<IHnInvoiceApplicationOrders> (`${hostUrl}/pay/hn-invoice/query-invoice-application-orders`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || {} as IHnInvoiceApplicationOrders;

      data = items || {} as IHnInvoiceApplicationOrders;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 完税开票 - 查询完税发票申请单关联异常订单
 */
export async function queryApprovalWarningOrder(param: IWarningOrdersParams) {
  let data = [] as IWarningFreelancer[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IWarningOrdersParams;

  try {
    const { code, context, message } = await Http.post<{ data: IWarningFreelancer[]; total: number }> (`${hostUrl}/pay/hn-invoice/query-warning-orders`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IWarningFreelancer[]; total: number};

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 完税开票 - 发票完税分页
 */
export async function queryInvoiceApplyPage(param: IInvoiceApplyPageParams) {
  let data = [] as IHnInvoiceApplyItem[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IInvoiceApplyPageParams;

  try {
    const { code, context, message } = await Http.post<{ data: IHnInvoiceApplyItem[]; total: number }> (`${hostUrl}/hainan/hn/invoiceApply/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IHnInvoiceApplyItem[]; total: number};

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 完税开票 - 导出
 */
/**
 * 完税开票 - 导出
 */
export async function queryInvoiceApplyExport(param: IInvoiceApplyPageParams) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  const isOffline = param?.hnInvoiceType === EHnInvoiceType.OFFLINE;

  try {
    const { code, context, message, headers } = await Http.get<Blob>(
      `${hostUrl}/hainan/hn/invoiceApply/export`,
      { ...param },
      { responseType: 'blob' },
    );
    
    if (isOffline) {
      if (headers['content-disposition']) {
        const match = headers['content-disposition'].match(/filename=(.+);?/);

        if (match && match[1]) {
          fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
        }
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName, 
  };
}

/**
 * 完税开票 - 下载发票
 */
export async function queryExportTaxInvoices(param: IExportTaxInvoicesParams, isCrowd: boolean = false) {
  try {
    const { code, message } = await Http.post<void>(
      `${hostUrl}/hainan/hn/batch-download-${isCrowd ? 'crowd' : 'match'}-tax-invoices`,
      param,
    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 完税开票 - 下载完税证明
 */
export async function queryExportTaxCertificates(param: IExportTaxInvoicesParams, isCrowd: boolean = false) {
  try {
    const { code, message } = await Http.post<void>(
      `${hostUrl}/hainan/hn/batch-download-${isCrowd ? 'crowd' : 'match'}-clearance-certificates`,
      param,
    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 完税开票 - 获取个税支付H5地址
 */
export async function queryInvoicePayH5Url(param: IInvoicePayH5UrlParams) {
  let data = {} as IInvoicePayH5Url;

  param = JSON.parse(JSON.stringify(param)) as IInvoicePayH5UrlParams;

  try {
    const { code, context, message } = await Http.post<IInvoicePayH5Url> (`${hostUrl}/hainan/hn/invoiceApply/pay`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || {} as IInvoicePayH5Url;

      data = items || {} as IInvoicePayH5Url;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 完税开票 - 发票完税详情
 */
export async function queryInvoiceApplyDetail(param: IHnInvoiceDetailParams) {
  let data = [] as IHnInvoiceDetailItem[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IHnInvoiceDetailParams;

  try {
    const { code, context, message } = await Http.post<{ data: IHnInvoiceDetailItem[]; total: number }> (`${hostUrl}/hainan/hn/invoiceApply/page/detail`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IHnInvoiceDetailItem[]; total: number};

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 完税开票 - 发票完税详情
 */
export async function queryOfflineDetail(id: number) {
  let data = {} as IHnInvoiceApplyItem;

  try {
    const { code, context, message } = await Http.get<IHnInvoiceApplyItem> (`${hostUrl}/hainan/hn/invoiceApply/detail`, { id });

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as IHnInvoiceApplyItem;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 完税开票 - 申请记录
 */
export async function queryInvoiceApplyRecord(param: IInvoiceApplyRecordParams) {
  let data = [] as IInvoiceApplyRecordItem[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IInvoiceApplyRecordParams;

  try {
    const { code, context, message } = await Http.post<{ data: IInvoiceApplyRecordItem[]; total: number }> (`${hostUrl}/pay/hn-invoice/page-query-invoice-applications`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IInvoiceApplyRecordItem[]; total: number; warningOrderCount: number; warningOrderAmount: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 完税开票 - 申请记录科目列表
 */
export async function queryRecordSubjectList(params: IRecordSubjectListParams) {
  let data = [] as IWarningOrdersList[];

  try {
    const { code, context, message } = await Http.post<IWarningOrdersList[]> (`${hostUrl}/pay/hn-invoice/query-invoice-subjects`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IWarningOrdersList[];

      data = items || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 *  完税开票/已开发票 - 导出
 */

export async function exportInvoiceApplyDetail(params: IHnInvoiceDetailParams) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/hainan/hn/invoiceApply/page/detailExport`,
      { ...params },
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 *  完税开票/已开发票 - 下载完税凭证
 */

export async function queryInvoiceReceiptUrl(id: number) {
  let url = '' as string;

  try {
    const { code, context, message } = await Http.get<string>(
      `${hostUrl}/hainan/hn/invoiceApply/receiptDownload`,
      { id },
    );

    if (code === EAxiosResponseCode.Succeed) {
      url = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return url;
}

/**
 * 完税开票 - 月度开票统计 - 统计
 */
export async function queryMonthStatistics(businessType: 2 | 3) {
  let obj = {} as IMonthInvoiceStatistics;

  try {
    const { code, context, message } = await Http.post<IMonthInvoiceStatistics> (`${hostUrl}/hainan/hn/invoice/month/statistics?businessType=${businessType}`);

    if (code === EAxiosResponseCode.Succeed) {
      obj = context || {} as IMonthInvoiceStatistics;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return obj;
}

/**
 * 完税开票 - 月度开票统计 - 分页
 */
export async function queryMonthInvoicePage(param: IMonthInvoiceParams) {
  let data = [] as IMonthInvoiceItem[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IMonthInvoiceParams;

  try {
    const { code, context, message } = await Http.post<{ data: IMonthInvoiceItem[]; total: number }> (`${hostUrl}/hainan/hn/invoice/month/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IMonthInvoiceItem[]; total: number};

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 *  完税开票 - 月度开票统计 - 导出
 */

export async function exportMonthInvoicePage(params: IMonthInvoiceParams) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(`${hostUrl}/hainan/hn/invoice/month/page/export`, { ...params }, { responseType: 'blob' });

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 完税开票 - 月度开票统计 - 企业/服务商列表
 */
export async function queryMonthCompanyList(companyName?: string) {
  let data = [] as IMonthCompanyItem[];

  try {
    const { code, context, message } = await Http.post<IMonthCompanyItem[]> (`${hostUrl}/side/tax/source/listForSettle`, { companyName });

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [] as IMonthCompanyItem[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 完税开票 - 众包 - 开票申请
 */
export async function queryCrowdInvoiceApply(param: ICrowdInvoiceApplyParams) {
  let data = [] as ICrowdInvoiceApplyItem[];
  let total = 0;
  let ids = [] as number[];

  param = JSON.parse(JSON.stringify(param)) as ICrowdInvoiceApplyParams;

  try {
    const { code, context, message } = await Http.post<{ data: ICrowdInvoiceApplyItem[]; total: number; orderDetailIds: number[] }> (`${hostUrl}/pay/tax-invoice/page-query-subject-crowd-order-detail-v2`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all, orderDetailIds } = context || {} as { data: ICrowdInvoiceApplyItem[]; total: number; orderDetailIds: number[] };

      data = items || [];
      total = all || 0;
      ids = orderDetailIds || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
    ids,
  };
}

/**
 * 完税开票 - 众包 - 开票申请 - 线下导出
 */
export async function exportCrowdInvoiceApply(params: ICrowdInvoiceApplyParams) {
  let buffer = null as Blob | null;
  let fileName = null;

  try {
    const { code, context, message, headers } = await Http.post<Blob>(
      `${hostUrl}/pay/tax-invoice/page-query-subject-crowd-order-detail-v2/export`,
      params,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName, 
  };
}

/**
 * 完税开票 - 众包 - 开票申请 - 开票科目、任务列表
 */
export async function queryCrowdInvoiceAndDutyList(serverId: number) {
  let data = {} as ICrowdInvoiceSubjectAndDutyList;

  try {
    const { code, context, message } = await Http.post<ICrowdInvoiceSubjectAndDutyList> (`${hostUrl}/pay/tax-invoice/query-crowd-order-invoice-subject-and-duty-list`, { serverId });

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as ICrowdInvoiceSubjectAndDutyList;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 完税开票 - 众包 - 开票申请 - 计算子订单汇总免税-含税金额
 */
export async function queryTaxOrderAmount(serverId: number, orderDetailIds: number[]) {
  let data = {} as IComputeFreeTaxOrderAmount;

  try {
    const { code, context, message } = await Http.post<IComputeFreeTaxOrderAmount> (`${hostUrl}/pay/tax-invoice/compute-crowd-free-tax-order-amount`, {
      serverId,
      orderDetailIds,
    });

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as IComputeFreeTaxOrderAmount;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 完税开票 - 撮合 - 开票申请 - 计算子订单汇总免税-含税金额
 */
export async function queryMatchTaxOrderAmount(params: IMatchTaxOrderAmountReq) {
  let data = {} as IComputeFreeTaxOrderAmount;

  try {
    const { code, context, message } = await Http.post<IComputeFreeTaxOrderAmount> (`${hostUrl}/pay/tax-invoice/compute-match-free-tax-order-amount`, params);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as IComputeFreeTaxOrderAmount;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 完税开票 - 众包 - 开票申请 - 提交众包订单开票申请。免税订单+含税订单同时提交
 */
export async function querySubmitCrowdApplication(serverId: number, invoiceSubjectId: number, orderDetailIds: number[]) {
  try {
    const { code, message } = await Http.post<void> (`${hostUrl}/pay/tax-invoice/merge-submit-crowd-orders-hn-invoice-application`, {
      serverId,
      invoiceSubjectId,
      orderDetailIds,
    });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 完税开票 - 撮合 - 开票申请
 */
export async function queryMatchInvoiceApply(param: ICrowdInvoiceApplyParams) {
  let data = [] as ICrowdInvoiceApplyItem[];
  let total = 0;
  let ids = [] as number[];

  param = JSON.parse(JSON.stringify(param)) as ICrowdInvoiceApplyParams;

  try {
    const { code, context, message } = await Http.post<{ data: ICrowdInvoiceApplyItem[]; total: number; orderDetailIds: number[] }> (`${hostUrl}/pay/tax-invoice/page-query-subject-match-order-detail-v2`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all, orderDetailIds } = context || {} as { data: ICrowdInvoiceApplyItem[]; total: number; orderDetailIds: number[] };

      data = items || [];
      total = all || 0;
      ids = orderDetailIds || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
    ids,
  };
}

/**
 * 用户中心 - 服务商列表
 */
export async function queryInvoiceServerList() {
  let data = [] as ICrowdServerItem[];

  try {
    const { code, context, message } = await Http.post<Array<ICrowdServerItem>>(`${hostUrl}/pay/tax-invoice/server-list`);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 用户中心 - 企业用户 - 企业列表
 */
export async function queryInvoiceCompanyList() {
  let data = [] as ICrowdCompanyItem[];

  try {
    const { code, context, message } = await Http.post<Array<ICrowdCompanyItem>>(`${hostUrl}/pay/tax-invoice/company-list`);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 完税开票 - 众包 - 开票申请 - 完税发送短信
 */
export async function sendSmsCustomerTax(orderDetailIds: number[]) {

  try {
    const { code, message } = await Http.post<void> (`${hostUrl}/iam/customer/tax/send-sms`, { orderDetailIds });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 *  完税开票/已开发票 - 打回订单
 */

export async function cancelInvoiceApplyDetail(ids: number[]) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/hainan/hn/invoice-detail-cancel`, { ids });

    if (code !== EAxiosResponseCode.Succeed) {
   
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 完税开票 - 上传完税申请文件（发票-完税凭证）
 */
export async function uploadInvoiceApplyFile(param: IUploadApplyFile) {

  try {
    const { code, message } = await Http.post<void> (`${hostUrl}/hainan/hn/upload-apply-file`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 完税开票 - 下载完税申请文件
 */
export async function downloadInvoiceApplyFile(applyId: number, fileBizType: 0 | 1) {
  let url = '';

  try {
    const { code, context, message } = await Http.post<string> (`${hostUrl}/hainan/hn/download-apply-file`, {
      applyId,
      fileBizType, 
    });

    if (code === EAxiosResponseCode.Succeed) {
      url = context || '' as string;
    } else {
      
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return url;
}

/**
 * 完税开票 - 获取线下完税发票/完税凭证url
 */
export async function queryInvoiceApplyFile(applyId: number, fileBizType: 0 | 1) {
  let urls = [] as string[];

  try {
    const { code, context, message } = await Http.post<string[]> (`${hostUrl}/hainan/hn/get-apply-file`, {
      applyId,
      fileBizType, 
    });

    if (code === EAxiosResponseCode.Succeed) {
      urls = context || [] as string[];
    } else {
      
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return urls;
}

/**
 * 完税开票 - 下载完税申请文件
 */
export async function exportInvoiceApplyFile(id: number) {
  try {
    const { code, message } = await Http.post<void> (`${hostUrl}/hainan/hn/export-off-line-detail/${id}`);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 完税开票 - 线下开票申请 - 校验超过开票限制并返回几笔订单和金额
 */
export async function queryInvoiceOfflineCheck(orderDetailIds: number[]) {
  let info = {} as ICheckInoviceRes;

  try {
    const { code, context, message } = await Http.post<ICheckInoviceRes>(`${hostUrl}/pay/tax-invoice/check-orders-hn-invoice-application`, { orderDetailIds });

    if (code === EAxiosResponseCode.Succeed) {
      info = context || {} as ICheckInoviceRes;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return info;
}
